var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import ErrorHandler from '@/support/ErrorHandler';
import { Student } from '@/models/Student';
import LoaderCard from '@/components/loader-card/LoaderCard';
import ProgressInterest from '@/views/Users/Student/Progress/ProgressInterest';
import ProgressLabel from '@/views/Users/Student/Progress/ProgressLabel';
import ProgressSkill from '@/views/Users/Student/Progress/ProgressSkill';
import ProgressAlbum from '@/views/Users/Student/Progress/ProgressAlbum';
import ProgressCitoResults from '@/views/Users/Student/Progress/ProgressCitoResults';
import PortfolioArchives from '@/views/Users/Student/Progress/PortfolioArchives';
import { ThisIsMeSetting } from '@/views/School/SchoolSettings/SchoolSettings';
let Progress = class Progress extends Vue {
    constructor() {
        super(...arguments);
        this.isLoadingPortfolioPage = false;
        this.isEditingTextareaChild = false;
        this.isEditingTextareaTeacher = false;
        this.isEditingTextareaGuardian = false;
        this.portfolio = null;
        // API Calls
        this.thisIsMeSettings = [];
        this.thisIsMeSettingsClone = [];
        this.thisIsMeSettingsLoaded = false;
        this.ThisIsMeSetting = ThisIsMeSetting;
    }
    // Lifecycle
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoadingPortfolioPage = true;
        await this.getThisIsMeSettings();
        await this.getPortfolio();
        this.isLoadingPortfolioPage = false;
    }
    getThisIsMeSetting(key) {
        const setting = this.thisIsMeSettings.find((setting) => {
            return setting.key === key;
        });
        return setting && setting.value ? setting.value : '-';
    }
    async getThisIsMeSettings() {
        this.thisIsMeSettingsLoaded = false;
        try {
            this.thisIsMeSettings = this.$store.state.settings.filter((setting) => {
                return setting.key && setting.key.startsWith('portfolio_');
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.thisIsMeSettingsLoaded = true;
        }
    }
    async getPortfolio() {
        if (!this.student.portfolio || !this.student.portfolio.id) {
            await this.fetchStudentPortfolio();
            return;
        }
        await this.fetchPortfolio();
    }
    async getPortfolioRatings() {
        if (!this.student.portfolio || !this.student.portfolio.id) {
            await this.fetchStudentPortfolio();
            return;
        }
        await this.fetchPortfolioSkills();
    }
    async fetchPortfolio() {
        const portfolioId = this.student.portfolio && this.student.portfolio.id
            ? this.student.portfolio.id
            : '';
        try {
            this.portfolio = await new PortfolioModel()
                .include([
                'interests',
                'skills',
                'labels',
                'ratings',
                'files',
                'category',
            ])
                .find(portfolioId);
        }
        catch (error) {
            //
        }
    }
    async fetchPortfolioSkills() {
        const portfolioId = this.student.portfolio && this.student.portfolio.id
            ? this.student.portfolio.id
            : '';
        try {
            const portfolio = await new PortfolioModel()
                .include([
                'skills',
                'category',
                'ratings',
            ])
                .find(portfolioId);
            if (this.portfolio && portfolio) {
                this.$set(this.portfolio, 'skills', portfolio.skills);
            }
        }
        catch (error) {
            //
        }
    }
    async fetchStudentPortfolio() {
        try {
            this.portfolio = await new PortfolioModel()
                .updatePortfolio({
                user: this.student.id,
                student_description: '',
                teacher_description: '',
            });
        }
        catch (error) {
            //
        }
    }
    updateTextarea() {
        if (!this.portfolio) {
            return;
        }
        const payload = {
            user: this.student.id,
            student_description: this.portfolio.student_description,
            teacher_description: this.portfolio.teacher_description,
            guardian_description: this.portfolio.guardian_description,
        };
        this.portfolio
            .updatePortfolio(payload)
            .then((portfolio) => {
            this.portfolio = portfolio;
            this.isEditingTextareaChild = false;
            this.isEditingTextareaTeacher = false;
            this.isEditingTextareaGuardian = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    // Getters
    get user() {
        return this.$store.state.Auth;
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Progress.prototype, "student", void 0);
Progress = __decorate([
    Component({
        components: {
            'loader-card': LoaderCard,
            'progress-interest': ProgressInterest,
            'progress-label': ProgressLabel,
            'progress-skill': ProgressSkill,
            'progress-album': ProgressAlbum,
            'progress-cito-results': ProgressCitoResults,
            'portfolio-archives': PortfolioArchives,
        },
    })
], Progress);
export default Progress;
